var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-datetextpicker',{attrs:{"value":_vm.value,"hide-details":_vm.hideDetails,"disabled":_vm.disabled,"loading":_vm.loading},on:{"input":_vm.updateSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }